<template>
	<vs-popup
		:title="''"
		:active.sync="popup_active_event_content"
		class="vs-popup--content-custom"
		button-close-hidden
	>
		<vx-card no-shadow :title="event.activity_name | title" :subtitle="'' + event.id">
			<template slot="actions">
				<div class="flex items-center justify-end gap-2">
					<vs-dropdown class="cursor-pointer flex" vs-custom-content>
						<!-- <feather-icon icon="TagIcon" svgClasses="h-5 w-5" @click.prevent></feather-icon> -->
						<vs-button
							radius
							type="flat"
							iconPack="feather"
							icon="icon-more-vertical"
							@click.prevent
						></vs-button>

						<vs-dropdown-menu style="z-index: 200001; min-width: 11rem">
							<vs-dropdown-item @click.stop="handleActions('followers')">
								<feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
								<span class="ml-2">{{ $t("Follower.FollowersConfiguration") }}</span>
							</vs-dropdown-item>
							<vs-dropdown-item @click.stop="handleActions('edit')">
								<feather-icon icon="EditIcon" svgClasses="w-4 h-4" />
								<span class="ml-2">{{ $t("Schedule.RescheduleVisit") }}</span>
							</vs-dropdown-item>

							<vs-dropdown-item @click.stop="handleActions('delete')">
								<feather-icon icon="TrashIcon" svgClasses="w-4 h-4" />
								<span class="ml-2">{{ $t("Crud.Delete") }} {{ $t("Schedule.Visit") }}</span>
							</vs-dropdown-item>
						</vs-dropdown-menu>
					</vs-dropdown>
					<vs-button
						radius
						icon-pack="feather"
						icon="icon-x"
						type="flat"
						@click="handleActions('close')"
					></vs-button>
				</div>
			</template>

			<!-- <img :src="cardImg" alt="content-img" class="responsive rounded-lg" /> -->

			<div class="my-6">
				<h5 class="mb-2 text-xl">{{ $t("VisitPoint") }}</h5>
				<p>{{ $t("Name") }}: {{ event.visit_point_name | title }}</p>
				<p>{{ $t("Identification") }}: {{ event.visit_point_identification }}</p>
				<p>{{ $t("Address") }}: {{ event.fullAddress() }}</p>
				<p class="mt-2">
					{{ $t("Reports.location") }}:
					<a
						title="Ver ubicación en Here Maps"
						:href="hereMapsUrl"
						target="_blank"
						style="margin: 10px 0px 10px 0px; color: #007bff; text-decoration: none"
						>Here Maps</a
					>
				</p>
			</div>

			<div class="flex justify-between flex-wrap">
				<span>
					<h5 class="mb-2 text-xl">{{ $t("Hour") }}</h5>
					<p>
						{{ event.init_hour }} -
						{{ event.end_hour }}
					</p>
				</span>
				<span>
					<h5 class="mb-2 text-xl">{{ $t("Date") }}</h5>
					<p>{{ event.date_prog }}</p>
				</span>
			</div>

			<vs-chip :color="resolveStatusColor" class="my-base">
				<p class="p-1 font-semibold text-lg">
					{{ resolveStatus }}
				</p>
			</vs-chip>

			<vs-divider></vs-divider>

			<div class="flex justify-end flex-wrap">
				<vs-button
					icon-pack="feather"
					icon="icon-edit"
					class="mt-4 mr-2 shadow-lg"
					@click="handleActions('edit')"
					>{{ $t("Schedule.RescheduleVisit") }}</vs-button
				>

				<vs-button
					icon-pack="feather"
					icon="icon-x"
					class="mt-4 mr-2 shadow-lg"
					@click="handleActions('cancel')"
					>{{ $t("Close") }}</vs-button
				>
			</div>
		</vx-card>
	</vs-popup>
</template>

<script>
export default {
	name: "EventPopupInformation",
	props: {
		event: {
			type: Object,
			required: true,
		},
		popupActiveEventContent: {
			type: Boolean,
			required: true,
			default: false,
		},
	},

	data() {
		return {
			cardImg: null,
		};
	},

	computed: {
		popup_active_event_content: {
			get() {
				return this.popupActiveEventContent;
			},
			set(value) {
				this.$emit("actions", "cancel");
			},
		},
		hereMapsUrl() {
			return `https://share.here.com/l/${this.event.coordinates()}`;
		},
		resolveStatus() {
			const status = this.event.event_status_id;
			const statusMap = {
				1: this.$t("Schedule.NotAssigned"),
				2: this.$t("Schedule.Scheduled"),
				3: this.$t("Schedule.ReProgramming"),
				4: this.$t("Schedule.Delayed"),
				5: this.$t("Schedule.OnTheWay"),
				6: this.$t("Schedule.InProgress"),
				7: this.$t("Schedule.Finished"),
				8: this.$t("Schedule.Canceled"),
			};
			return statusMap[status] || this.$t("Schedule.NotAssigned");
		},
		resolveStatusColor() {
			const status = this.event.event_status_id;
			const statusMap = {
				1: "#886ce4",
				2: "#28c76f",
				3: "#006eff",
				4: "#ff7070",
				5: "#ffbe81",
				6: "#ff7070",
				7: "#ff9f43",
				8: "#ff0000",
			};
			return statusMap[status] || "#a0a0a0";
		},
	},
	methods: {
		handleActions(action) {
			this.$emit("actions", action);
		},
		fetchScheduleMapStaticImageRequests() {
			const staticMapsImage = this.$store.getters["moduleSchedule/getEventStaticMapsImageRequest"](
				this.event.visit_point_id
			);
			if (staticMapsImage) {
				this.cardImg = staticMapsImage;
				return;
			}
			this.$store
				.dispatch("moduleSchedule/fetchScheduleMapStaticImageRequests", {
					visitPointId: this.event.visit_point_id,
					cx: this.event.cx,
					cy: this.event.cy,
				})
				.then((response) => {
					if (response) {
						this.cardImg = response.imageBlob;
					}
				});
		},
		goToFollowers() {
			this.$router.push("/apps/calendar/follower");
		},
	},
};
</script>

<style scoped></style>
